import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { setDocumentResources, updateDocResource } from 'data/documents';
function* updateDocResourceManager(action) {
    const { payload } = action;
    try {
        yield put(setDocumentResources(payload.resourceSections));
        yield DocumentsAPI.updateDocumentResources(payload);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
    // TODO: handle error
    }
}
export const watchUpdateDocResourceSections = function*() {
    yield takeLatest(updateDocResource.type, updateDocResourceManager);
};
